'use strict';

var Wrapper = require('./Wrapper.js');
var Cell = require('./Cell.js');

const Grid = {
    Wrapper: Wrapper.GridWrapper,
    Cell: Cell.GridCell,
};

exports.Grid = Grid;
//# sourceMappingURL=index.js.map
